<template>
  <div class="space-y-2">
    <h3 class="text-sm font-semibold text-white">Advanced Template</h3>

    <VAceEditor
      v-model:value="binding.template"
      lang="django"
      :theme="editorStore.theme"
      :options="editorOptions"
      class="w-full border border-slate-600 rounded"
      style="height: 180px" />

    <button type="button" class="text-xs text-red-400 hover:text-red-300" @click="binding.template = ''">
      Clear Template
    </button>
  </div>
</template>

<script setup>
/**
 * TemplateBindingEditor.vue
 *
 * Editor for the 'template' binding strategy — a raw Jinja2 expression.
 * Resolved and rendered by BindingEditorRouter.vue; never referenced by
 * name from StateBindingsTable.
 *
 * Multiline Ace editor (VAceEditor, already used elsewhere in the app for
 * YAML/JSON export — see export/HassConfigTab.vue) rather than a
 * single-line input, so this reads as a dedicated editor rather than a
 * cramped text box. `lang="django"` is the closest built-in Ace mode to
 * Jinja2 (same {{ }}/{% %} delimiters) — ace-builds has no dedicated
 * Jinja2 mode. Autocompletion/live validation/preview are deliberately
 * not wired up yet ("UX Polish" phase, not the later validation phase) —
 * `enableBasicAutocompletion`/`enableLiveAutocompletion` are left off.
 *
 * "Clear Template" is the only action that empties binding.template —
 * switching strategy away from (or back to) Advanced Template never does,
 * see StateBindingsTable.vue's returnToStructuredStrategy().
 */
import { VAceEditor } from 'vue3-ace-editor';
import { useEditorStore } from '../../../stores/editorStore.js';
import 'ace-builds/src-noconflict/mode-django';
import '../../../ace-config';

defineProps({
  binding:     { type: Object, required: true }, // AutomationBinding — mutated directly
  editorState: { type: Object, required: true },  // BindingEditorState — unused here, kept for a uniform editor prop shape
});

const editorStore = useEditorStore();

const editorOptions = {
  showGutter: true,
  wrap: true,
  fontSize: 12,
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: false,
};
</script>
